import { call, put, takeLatest } from 'redux-saga/effects';
import Country from '../../api/country';
import {
  actionTypes,
  getAllCountriesSuccess,
  getAllRegionsSuccess,
  getCountriesSuccess,
  getCountrySuccess,
  updateCountrySuccess,
} from '../actions/country';

function* getAllRegions() {
  try {
    const result = yield call(() => Country.getAllRegions());
    const simpleFiltersShaped = result?.map(el => ({ id: el, name: el }));
    yield put(getAllRegionsSuccess(simpleFiltersShaped));
  } catch (error) {
    console.log(error);
  }
}

function* getAllCountries() {
  try {
    const result = yield call(() =>
      Country.getCountries({
        limit: 1000,
        page: 1,
        orderData: { orderBy: 'name', sortDirection: 'ASC' },
        regionFilter: undefined,
      }),
    );
    const simpleFiltersShaped = result?.rows?.map(el => ({ id: el.id, name: el.name }));
    yield put(getAllCountriesSuccess(simpleFiltersShaped));
  } catch (error) {
    console.log(error);
  }
}

function* getCountries(action) {
  try {
    const result = yield call(() => Country.getCountries(action.payload));
    yield put(getCountriesSuccess(result));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(null, error?.response?.data?.message);
  }
}

function* getCountry(action) {
  try {
    const result = yield call(() => Country.getCountry(action.payload));
    yield put(getCountrySuccess(result));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(null, error?.response?.data?.message);
  }
}

function* createCountry(action) {
  try {
    const result = yield call(() => Country.createCountry(action.payload));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(null, error?.response?.data?.message);
  }
}

function* updateCountry(action) {
  try {
    const result = yield call(() => Country.updateCountry(action.payload.id, action.payload));
    yield put(updateCountrySuccess(result));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(null, error?.response?.data?.message);
  }
}

export default function* countrySaga() {
  yield takeLatest(actionTypes.GET_ALL_REGIONS, getAllRegions);
  yield takeLatest(actionTypes.GET_ALL_COUNTRIES, getAllCountries);
  yield takeLatest(actionTypes.GET_COUNTRIES, getCountries);
  yield takeLatest(actionTypes.GET_COUNTRY, getCountry);
  yield takeLatest(actionTypes.CREATE_COUNTRY, createCountry);
  yield takeLatest(actionTypes.UPDATE_COUNTRY, updateCountry);
}
